/**
 * Created by lenovo on 2017/5/11.
 */
import React, {Component, PropTypes} from 'react';
import {Link, browserHistory} from "react-router";

var moment = require('moment');
import FormInput from 'CONFIG/component/form/formInput'
import FormInputSimple from 'CONFIG/component/form/formInputSimple'
import FormSelect from 'CONFIG/component/form/formSelect'
var clearFlag = false;
import {ellaUrl} from '../../../path.config'
import Tip from 'COMPONENT/tip'
import {resultTip,language,errorShow} from 'UTIL/common'
import userService from 'SERVICES/ella/userService'
const roleList = [];
import ellaService from 'SERVICES/purifier/ella/ellaService'
function nodeChildren(nodeList) {
    for (let i in nodeList) {
        var arr = {}
        arr = {
            id: nodeList[i].id,
            pId: nodeList[i].pId,
            name: nodeList[i].name
        };
        roleList.push(arr);
        if (nodeList[i].children.length > 0) {
            nodeChildren(nodeList[i].children)
        }
    }
    return roleList;
}
export default class NormalUserDetail extends Component {
    constructor(props) {
        super(props);
        // this.fetchExtendsValue = this.fetchExtendsValue.bind(this);
        this.state = {
            roleList: [],
            userType: [],
            extendsValue: [],
            url: ellaUrl,
            userBase : {},
        };
    }

    componentDidMount() {
        var id = this.props.params.id;
        ellaService.userToUpdate(id).then(data=>{
            console.log(data)
            if (data.data != null) {
                var userBase = data.data.userBase;
                var selectRole = data.data.selectRole;
                var userType = data.data.userType;
                var userExtendValues = data.data.userExtendValues;


                this.setState({
                    map: data.data,
                    userBase: data.data.userBase,
                    roleList: data.data.roleList,
                    dvcTypes: userBase.dvcTypes,
                    selectRole: selectRole,
                    userType: userType,
                    userExtendValues: userExtendValues,
                })

            }
        })
    }
    render() {
        const row = this.state.userBase;
        return (
            <div >
                <section className="content-header ">
                    <h1> {language()['userManage']}
                        <small>{language()['normalUserDetail']}</small>
                    </h1>
                </section>
                <section className="content">
                    <div className="box box-primary color-palette-box">
                        <div className="box-header with-border">
                            <i className="fa fa-plus-circle"></i>
                            <h3 className="box-title">{language()['normalUserDetail']}</h3>
                        </div>
                        <div className="box-body">
                            <table id="yjcz" className="table table-bordered table-striped dataTable">
                                <tbody>
                                <tr>
                                    <td className="fontWeightBig">{language()['loginName']}</td>
                                    <td className="fontWeightSmall">{row.loginName}</td>
                                    <td className="fontWeightBig">{language()['address']}</td>
                                    <td className="fontWeightSmall">{row.address}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="box-footer">
                            <div className="col-xs-5 text-center">
                            </div>
                            <div className="col-xs-2 text-center">
                                <Link to={"/ella/user/user/NormalUser"} className="btn btn-default">{language()['return']}</Link>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./modules/ella/user/user/normalUserDetail.js